<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [dismissableMask]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{width: '72rem', maxWidth: '94vw'}"
  [header]="'project.steps.providerResults.individual.title' | transloco: {tool: toolName() ?? ''}"
  data-testid="rfi-individual-results-modal"
>
  @if (visible()) {
    <div class="flex flex-col gap-6">
      <app-rfi-score-summary-cards [scores]="evaluatedScores()" />

      <p-accordion [multiple]="true">
        @if (score(financeScNumber); as sectionScore) {
          <p-accordion-panel [value]="financeScNumber" data-testid="individual-section-finance">
            <p-accordion-header>
              <app-rfi-section-header [score]="sectionScore" />
            </p-accordion-header>
            <p-accordion-content>
              <app-rfi-finance-section
                [completeness]="financeCompleteness()"
                [cards]="financeCards()"
                [chartData]="financeChartData()"
              />
            </p-accordion-content>
          </p-accordion-panel>
        }

        @if (score(companyScNumber); as sectionScore) {
          <p-accordion-panel [value]="companyScNumber" data-testid="individual-section-company">
            <p-accordion-header>
              <app-rfi-section-header [score]="sectionScore" />
            </p-accordion-header>
            <p-accordion-content>
              <app-rfi-company-section
                [completeness]="companyCompleteness()"
                [cards]="companyCards()"
                [employeeBreakdown]="employeeBreakdown()"
              />
            </p-accordion-content>
          </p-accordion-panel>
        }

        @if (score(cultureScNumber); as sectionScore) {
          <p-accordion-panel [value]="cultureScNumber" data-testid="individual-section-culture">
            <p-accordion-header>
              <app-rfi-section-header [score]="sectionScore" />
            </p-accordion-header>
            <p-accordion-content>
              <app-rfi-culture-section
                [completeness]="cultureCompleteness()"
                [groups]="cultureGroups()"
              />
            </p-accordion-content>
          </p-accordion-panel>
        }

        @if (score(referenceScNumber); as sectionScore) {
          <p-accordion-panel
            [value]="referenceScNumber"
            data-testid="individual-section-references"
          >
            <p-accordion-header>
              <app-rfi-section-header [score]="sectionScore" />
            </p-accordion-header>
            <p-accordion-content>
              <app-rfi-references-section
                [completeness]="referenceCompleteness()"
                [answers]="referenceAnswers()"
              />
            </p-accordion-content>
          </p-accordion-panel>
        }
      </p-accordion>

      <span class="text-muted-color text-xs">
        {{ 'project.steps.providerResults.individual.selfDisclosureHint' | transloco }}
      </span>
    </div>
  }
</p-dialog>
